<template lang="pug">
div
  div.d-flex.align-center.mb-2(v-if="isSheet")
    div.text-sm.font-semibold.neutral700--text Vital signs
    v-spacer
    y-button(label="View full vital chart" outlined color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" height="24" button-class="px-2" @click="showVitalSignsDialog = true")
  v-card.round-xl(outlined :loading="isFetching")
    v-card-title.neutral200.px-3.py-2
      div.d-flex.align-center(style="width: 100%;")
        div.text-xs.font-medium.neutral700--text.mr-3(v-if="isTable") Vital signs
        template(v-if="vitalsign")
          div.text-xs.neutral700--text {{ $options.filters.convertServerDate3(vitalsign.recorded_at) }}
          div.ml-3.mt-n1
            v-btn(icon small :disabled="!previous" @click="fetchPrevious(previous)")
              v-icon(size="20" color="neutral500") mdi-chevron-left
            v-btn(icon small :disabled="!next" @click="fetchNext(next)")
              v-icon(size="20" color="neutral500") mdi-chevron-right
        v-spacer
        y-button.mr-3(v-if="isTable" label="View full vital chart" outlined color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" height="24" button-class="px-2" @click="showVitalSignsDialog = true")
        y-button(label="Record new" outlined color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" height="24" button-class="px-2" @click="showAddVitalSignsDialog = true")
        y-button.ml-3(v-if="vitalsign" label="Edit" outlined color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" height="24" button-class="px-2" @click="showEditVitalSignsDialog = true")
    v-divider
    v-card-text.pa-0
      div.d-flex.align-center.justify-center.my-3(v-if="!vitalsign")
        div.text-sm.neutral700--text No vital signs recorded.
        y-button.ml-3(label="Record vital signs" color="neutral300" prepend-icon="mdi-plus" icon-size="18" icon-color="neutral500" unset-min-width size="xxs" button-class="px-2" @click="showAddVitalSignsDialog = true")
      template(v-else)
        //- type table
        v-simple-table.custom(v-if="isTable" dense)
          thead
            tr
              th.neutral500--text(style="text-transform: none !important;") Ht (cm)
              th.neutral500--text(style="text-transform: none !important;") Wt (kg)
              th.neutral500--text(style="text-transform: none !important;") Temp (C)
              th.neutral500--text(style="text-transform: none !important;") BP (mmHg)
              th.neutral500--text(style="text-transform: none !important;") HR/Pulse
              th.neutral500--text(style="text-transform: none !important;") SpO2
              th.neutral500--text(style="text-transform: none !important;") BG mmol/L
              th.neutral500--text(style="text-transform: none !important;") RR
          tbody
            tr
              td.text-sm.neutral700--text {{ vitalsign.height || '-' }}
              td.text-sm.neutral700--text {{ vitalsign.weight || '-' }}
              td.text-sm.neutral700--text {{ vitalsign.temperature ? `${vitalsign.temperature }°` : '-' }}
              td.text-sm.neutral700--text {{ vitalsign.bp_systolic ? `${vitalsign.bp_systolic}/${vitalsign.bp_diastolic}` : '-' }}
              td.text-sm.neutral700--text {{ vitalsign.pulse ? `${vitalsign.pulse } bpm` : '-' }}
              td.text-sm.neutral700--text {{ vitalsign.spo2 ? `${vitalsign.spo2 }%` : '-' }}
              td.text-sm.neutral700--text {{ vitalsign.blood_glucose || '-' }}
              td.text-sm.neutral700--text {{ vitalsign.respiratory_rate || '-' }}
        //- type sheet
        v-sheet.pa-3(v-if="isSheet")
          v-row(dense)
            v-col(cols="3")
              div.text-xs.neutral500--text(style="text-transform: none !important;") Ht (cm)
              div.text-sm.neutral700--text(style="text-transform: none !important;") {{ vitalsign.height || '-' }}
            v-col(cols="3")
              div.text-xs.neutral500--text(style="text-transform: none !important;") Wt (kg)
              div.text-sm.neutral700--text(style="text-transform: none !important;") {{ vitalsign.weight || '-' }}
            v-col(cols="3")
              div.text-xs.neutral500--text(style="text-transform: none !important;") Temp (C)
              div.text-sm.neutral700--text(style="text-transform: none !important;") {{ vitalsign.temperature ? `${vitalsign.temperature }°` : '-' }}
            v-col(cols="3")
              div.text-xs.neutral500--text(style="text-transform: none !important;") BP (mmHg)
              div.text-sm.neutral700--text(style="text-transform: none !important;") {{ vitalsign.bp_systolic ? `${vitalsign.bp_systolic}/${vitalsign.bp_diastolic}` : '-' }}
          v-row(dense)
            v-col(cols="3")
              div.text-xs.neutral500--text(style="text-transform: none !important;") HR/Pulse
              div.text-sm.neutral700--text(style="text-transform: none !important;") {{ vitalsign.pulse ? `${vitalsign.pulse } bpm` : '-' }}
            v-col(cols="3")
              div.text-xs.neutral500--text(style="text-transform: none !important;") SpO2
              div.text-sm.neutral700--text(style="text-transform: none !important;") {{ vitalsign.spo2 ? `${vitalsign.spo2 }%` : '-' }}
            v-col(cols="3")
              div.text-xs.neutral500--text(style="text-transform: none !important;") BG mmol/L
              div.text-sm.neutral700--text(style="text-transform: none !important;") {{ vitalsign.blood_glucose || '-' }}
            v-col(cols="3")
              div.text-xs.neutral500--text(style="text-transform: none !important;") RR
              div.text-sm.neutral700--text(style="text-transform: none !important;") {{ vitalsign.respiratory_rate || '-' }}
  .dialogs
    vital-signs-dialog(v-if="showVitalSignsDialog" :open.sync="showVitalSignsDialog" @updated="fetchVitalSign")
    add-vital-signs-dialog(v-if="showAddVitalSignsDialog" :open.sync="showAddVitalSignsDialog" @updated="fetchVitalSign")
    edit-vital-signs-dialog(v-if="showEditVitalSignsDialog" :open.sync="showEditVitalSignsDialog" :vital-sign="vitalsign" @updated="updateVitalSign($event)")
              
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VitalSignsDialog from '@/components/clinic/consultation/VitalSignsDialog.vue'
import AddVitalSignsDialog from '@/components/clinic/consultation/AddEditVitalSignsDialog.vue'
import EditVitalSignsDialog from '@/components/clinic/consultation/AddEditVitalSignsDialog.vue'

export default {
  components: { VitalSignsDialog, AddVitalSignsDialog, EditVitalSignsDialog },
  props: {
    type: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isFetching: false,
      showVitalSignsDialog: false,
      showAddVitalSignsDialog: false,
      showEditVitalSignsDialog: false,
      vitalsign: null,
      next: null,
      previous: null,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      pid: 'treatment/getLeadPid',
      hqSelectedCompany: 'hq/getSelectedCompany',
      isHq: 'hq/getIsHq'
    }),
    isTable () {
      return this.type === 'table'
    },
    isSheet () {
      return this.type === 'sheet'
    }
  },
  mounted () {
    this.fetchVitalSign()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchVitalSign () {
      this.isFetching = true
      let params = {
        page_size: 1,
        ordering: 'recorded_at'
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      this.$axios.get(`/clinics/${companySlug}/consultations/${this.pid}/vital_signs`, { params })
        .then(resp => {
          if (resp.data.results.length) {
            this.vitalsign = resp.data.results[0]
          } else {
            this.vitalsign = null
          }
          this.next = resp.data.next
          this.previous = resp.data.previous
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchNext (next) {
      this.isFetching = true
      const url = new URL(next)
      const endpoint = next.replace(url.origin, '')
      this.$axios.get(endpoint)
        .then(resp => {
          if (resp.data.results.length) this.vitalsign = resp.data.results[0]
          this.next = resp.data.next
          this.previous = resp.data.previous
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchPrevious (previous) {
      this.isFetching = true
      const url = new URL(previous)
      const endpoint = previous.replace(url.origin, '')
      this.$axios.get(endpoint)
        .then(resp => {
          if (resp.data.results.length) this.vitalsign = resp.data.results[0]
          this.next = resp.data.next
          this.previous = resp.data.previous
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    updateVitalSign (data) {
      this.vitalsign = data
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .custom.v-data-table {
    border-bottom-left-radius: 10px !important;
    border-bottom-right-radius: 10px !important;
    .v-data-table__wrapper table thead tr:last-child th {
      border-bottom: none;
    }
  }
}
</style>